module.exports = __webpack_public_path__ + "assets/img/00148.3e06ac9e.png";